import React from "react";

interface IContentProps {
  children?: React.ReactElement;
}
export const Content: React.FC<IContentProps> = ({ children }) => {
  return (
    <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain p-4">
        {children}
      </div>
    </main>
  );
};
